import React, { useState, useEffect } from 'react';
import { DataGrid } from '@material-ui/data-grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import { Typography, Box } from '@material-ui/core';
import UserDialog from './UserDialog';
import { UsersService } from '../../../api/users.services';
import { useSelector } from 'react-redux';
import AddIcon from '@material-ui/icons/Add';

export default function UsersTab() {
	const [loading, setLoading] = useState(false);
	const [users, setUsers] = useState([]);
	const [openDialog, setOpenDialog] = useState(false);
	const [currentUser, setCurrentUser] = useState(null);

	// Obtenemos el usuario conectado
	const currentUserConnection = useSelector((state) => state.User);
	const loggedInUser = currentUserConnection.user
		? currentUserConnection.user
		: null;

	const loadUsers = async () => {
		setLoading(true);
		try {
			const usersData = await UsersService.getUsersService();
			if (usersData) {
				// Excluir al usuario actual
				const filteredUsers = usersData.filter((user) => {
					return user.id !== loggedInUser.id;
				});

				setUsers(filteredUsers);
			}
		} catch (error) {
			console.error('Error al cargar usuarios:', error);
		} finally {
			setLoading(false);
		}
	};

	// eslint-disable-next-line
	useEffect(() => {
		loadUsers();
		// eslint-disable-next-line
	}, [loggedInUser]);

	const handleAddUser = () => {
		setCurrentUser(null);
		setOpenDialog(true);
	};

	const handleEditUser = (user) => {
		setCurrentUser(user);
		setOpenDialog(true);
	};

	const handleSaveUser = async (userData, handleResetPassword) => {
		try {
			if (userData.id) {
				await UsersService.updateUserService(userData);
			} else {
				delete userData.id;
				const result = await UsersService.createUserService(userData);
				await handleResetPassword(result.id);
			}
			loadUsers();
			setOpenDialog(false);
		} catch (error) {
			console.error('Error al guardar usuario:', error);
		}
	};

	const handleDeleteUser = async (user) => {
		try {
			await UsersService.deleteUserService(user.id);
			loadUsers();
		} catch (error) {
			console.error('Error al eliminar usuario:', error);
		}
	};

	const columns = [
		{
			field: 'admin',
			headerName: 'Type',
			width: 150,
			renderCell: (params) => (
				<span>{params.value ? 'Administrador' : 'Usuario'}</span>
			),
		},
		// { field: 'id', headerName: 'ID', width: 90 },
		{ field: 'user', headerName: 'Usuario', flex: 1 },
		{ field: 'email', headerName: 'Email', flex: 1 },
		// { field: 'equipo', headerName: 'Equipo', width: 200 },
		{
			field: 'actions',
			headerName: '#',
			width: 50,
			renderCell: (params) => (
				<IconButton
					size='small'
					color='primary'
					onClick={() => handleEditUser(params.row)}>
					<EditIcon />
				</IconButton>
			),
		},
	];

	return (
		<div>
			<Box
				display='flex'
				justifyContent='space-between'
				alignItems='center'
				mb={2}>
				<Typography variant='h6'>Gestión de Usuarios</Typography>
				<Button
					variant='contained'
					color='primary'
					startIcon={<AddIcon />}
					onClick={handleAddUser}>
					Añadir Usuario
				</Button>
			</Box>

			<div style={{ height: 500, width: '100%' }}>
				<DataGrid
					rows={users}
					columns={columns}
					pageSize={100}
					loading={loading}
					disableSelectionOnClick
				/>
			</div>

			<UserDialog
				open={openDialog}
				onClose={() => setOpenDialog(false)}
				user={currentUser}
				onSave={handleSaveUser}
				onDelete={handleDeleteUser}
			/>
		</div>
	);
}
